"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _reactTransitionGroup = require("react-transition-group");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
var AnimatedRoute = /*#__PURE__*/function (_react$default$Compon) {
  function AnimatedRoute() {
    _classCallCheck(this, AnimatedRoute);
    return _callSuper(this, AnimatedRoute, arguments);
  }
  _inherits(AnimatedRoute, _react$default$Compon);
  return _createClass(AnimatedRoute, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        renderSwitch = _this$props.renderSwitch,
        location = _this$props.location,
        animationType = _this$props.animationType;
      return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        key: location.key,
        timeout: 400,
        classNames: animationType
      }, renderSwitch(location)));
    }
  }]);
}(_react.default.Component);
var _default = exports.default = (0, _reactRouterDom.withRouter)(AnimatedRoute);